import React, { useEffect, useState } from "react";
import { Dialog, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import { getAllData, addData } from "../../Utility/API";
import { endPoints } from "../../constant/Environment";
import { useSelector } from "react-redux";

const MarketingPopup = () => {
  const [banner, setBanner] = useState(null);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth);
  const { IsLoginData, isAuthenticated } = authState;

  useEffect(() => {
    fetchBanner();
  }, []);

  const fetchBanner = async () => {
    try {
      const url = `${endPoints.api.GET_MARKETING_POPUP}/${IsLoginData?.idUser}`;
      const response = await getAllData(url);
      if (response?.status === "success" && response?.data?.length > 0) {
        const activeBanner = response.data.find(
          (b) => b.click_count < b.login_attempt
        );
        if (activeBanner) {
          setBanner(activeBanner);
          setOpen(true);
        }
      }
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  const handleClose = () => {
    if (banner?.id) {
      Checkuser(banner.id);
    }
    setOpen(false);
  };

  const Checkuser = async (id) => {
    setIsLoading(true);
    let data = {
      id_user: IsLoginData?.idUser,
      banner_id: id,
    };
    let url = `${endPoints.api.CHECK_USER}`;
    await addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status == "success") {
          // SuccesToast(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const handleCTAClick = () => {
    if (banner?.link) {
      try {
        const url = new URL(banner.link);
        const relativePath = url.pathname + url.search;
        navigate(relativePath);
      } catch (error) {
        navigate(banner.link);
      }
      handleClose();
    }
  };

  if (!banner) return null;

  const mobileImageUrl = `${endPoints.imageCDN}${banner.mobile_image}`;
  const webImageUrl = `${endPoints.imageCDN}${banner.web_image}`;

  return (
    <Dialog
      open={open}
      // onClose={handleClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          margin: 0,
          maxWidth: { xs: "100%", md: "900px" },
          backgroundColor: "transparent",
          boxShadow: "none",
          overflow: "visible",
        },
      }}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.90)",
        },
      }}
    >
      <Box sx={{ 
        position: "relative", 
        width: "100%", 
        height: "100%",
        // border: "2px solid white",
        // borderRadius: "8px",
        boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.5)",
        overflow: "hidden"
      }}>
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            bgcolor: "rgba(0, 0, 0, 0.6)",
            color: "white",
            zIndex: 2,
            width: 40,
            height: 40,
            "&:hover": {
              bgcolor: "rgba(0, 0, 0, 0.9)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          component="img"
          alt={banner.title || "Banner"}
          onClick={banner?.link ? handleCTAClick : undefined}
          sx={{
            position: 'relative',
            zIndex: 1,
            maxWidth: "100%",
            display: "block",
            cursor: banner?.link ? "pointer" : "default",
            content: {
              xs: `url(${mobileImageUrl})`,
              md: `url(${webImageUrl})`
            },
            "&:hover": banner?.link ? {
              opacity: 0.95,
            } : {},
          }}
        />
      </Box>
    </Dialog>
  );
};

export default MarketingPopup;
